// extracted by mini-css-extract-plugin
export default {"option":"WUPboBNDpHWwVV0hWrTM","selected":"Z4ES74oNb7Y9NKzC5nSm","outline":"DzULhzZnmyplhXpUfnOF","dark":"CHnOK3s9Qwx2DtZZMgpQ"};